
export const textStyles = {
    heading: "text-3xl font-bold text-foreground mb-8",
    subheading: "text-xl md:text-2xl text-foreground/70 mb-8",
    paragraph: "text-foreground/70"
};

export const layoutStyles = {
    section: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4",
    navSection: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4",
    contentSection: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16",
    flexCenter: "flex items-center justify-center",
    flexBetween: "flex items-between justify-between"
};